import { Tag } from '#app/components/ui/tag.tsx'

interface AboutProgramSectionProps {
	className?: string
}

export function AboutProgramSection({ className }: AboutProgramSectionProps) {
	return (
		<section className={className}>
			<div className="container mx-auto max-w-[1200px] px-[37.5px] py-16 md:px-4">
				{/* Tag */}
				<div className="mb-14">
					<Tag
						variant="secondary"
						appearance="solid"
						color="green"
						size="l"
						option="text-icon-left"
						leftIcon="service"
					>
						Proyecto
					</Tag>
				</div>

				{/* Content Container */}
				<div className="flex flex-col gap-8 md:flex-row md:items-center md:gap-[136px]">
					{/* Text Content */}
					<div className="flex flex-1 flex-col gap-10">
						<h2 className="font-parkinsans text-txt-primary text-4xl leading-[70px] font-medium md:text-[56px]">
							¿Qué es el <span className="text-green-500">Educa ConCiencia?</span>
						</h2>
						<p className="font-inter text-txt-secondary text-base leading-[26px] font-normal">
							El Educa ConCiencia nace con un propósito claro: educar,
							concientizar y actuar frente al Cambio Climático en el ámbito
							escolar, de manera transversal, participativa y medible. Está
							destinado a estudiantes y docentes de nivel secundario de
							Argentina y el mundo, y propone acciones concretas con impacto
							directo y replicable.
						</p>
					</div>

					{/* Image */}
					<div className="h-[400px] w-full shrink-0 overflow-hidden rounded-[24px] md:h-[620px] md:w-[488px]">
						<img
							src="/resources/images?src=/img/programa-madre/programa-madre-que-es.png&w=488&h=620&format=webp"
							alt="Educa ConCiencia - Estudiantes en el aula"
							className="h-full w-full object-cover"
						/>
					</div>
				</div>
			</div>
		</section>
	)
}

export default AboutProgramSection
